import AboutUsPage from "@/components/about-us/AboutUsPage";
import NotFound from "@/components/common/NotFound";
import { isCommunityPortal } from "@/utils/type";

const AboutUs = ({ type }) => {
    return isCommunityPortal(type) ? <AboutUsPage communityPortal={true} /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default AboutUs;
